import React from 'react';
import PropTypes from 'prop-types';
import { BoxBlock } from '@components/page/BlockRenderer';
import { useAppContext } from '@/context/AppContext';
import { FADE_DURATION } from '../imageViewerUtils';

/**
 * On a phone, the blocks placed on a slideshow slide, after its pictures, at
 * reading size and in reading order. Scrolls when they don't fit.
 */
export default function SpreadReadingSlide({ boxes, page, pages, files, theme }) {
    const { content, theme: siteTheme } = useAppContext();
    const blockProps = {
        page,
        pages: pages || content?.pages || {},
        files: files || content?.files || {},
        theme: theme || siteTheme,
    };
    return (
        <div
            data-reading-slide
            className="h-full w-full overflow-y-auto bg-background"
            style={{ touchAction: 'pan-y', transition: `background-color ${FADE_DURATION}ms ease-in-out` }}
        >
            <div className="mx-auto flex min-h-full w-full max-w-prose flex-col justify-center gap-8 px-6 py-16">
                {boxes.map((box) => (
                    <div
                        key={box.id}
                        style={{
                            background: box.bg || undefined,
                            padding: box.pad ? `${Math.min(box.pad, 32)}px` : undefined,
                        }}
                    >
                        <BoxBlock block={box.block} {...blockProps} />
                    </div>
                ))}
            </div>
        </div>
    );
}

SpreadReadingSlide.propTypes = {
    /** Boxes from lib/slideshow/boxes, already in reading order. */
    boxes: PropTypes.array.isRequired,
    page: PropTypes.object,
    pages: PropTypes.object,
    files: PropTypes.object,
    theme: PropTypes.object,
};
